<form [formGroup]="iosForm">
  <div>
    <ul class="mb-2 nav nav-tabs border-0">
      <li class="nav-item">
        <button
          [class.active]="tabs === 0"
          type="button"
          (click)="tabs = 0"
          class="nav-link"
        >
          Informações gerais
        </button>
      </li>
      <li class="nav-item">
        <button
          [disabled]="!parentForm().controls['accountantId'].valid"
          [class.active]="tabs === 1"
          type="button"
          (click)="tabs = 1"
          class="nav-link"
        >
          Arquivos
        </button>
      </li>
    </ul>

    <div [class.d-none]="tabs !== 0" class="gap-1 row">
      <div class="col-md-4">
        <label>Status</label>
        <div class="input-group mb-1">
          <select formControlName="status" class="form-select">
            <option value="0">Não publicado</option>
            <option value="1">Publicado</option>
          </select>
        </div>

        <label for="app-id">App Id</label>
        <div class="input-group mb-1">
          <input
            maxlength="10"
            formControlName="appId"
            class="form-control"
            id="app-id"
            type="text"
          />
        </div>

        <label for="development-team">Development Team</label>
        <div class="input-group mb-1">
          <input
            maxlength="10"
            formControlName="developmentTeam"
            class="form-control"
            id="development-team"
            type="text"
          />
        </div>

        <label for="ios-bundle-id">Ios Bundle Id</label>
        <div class="input-group mb-1">
          <input
            formControlName="iosBundleId"
            class="form-control"
            id="ios-bundle-id"
            type="text"
          />
        </div>

        <label for="application-group">Application Group</label>
        <div class="input-group mb-1">
          <input
            formControlName="applicationGroup"
            class="form-control"
            id="application-group"
            type="text"
          />
        </div>

        <label for="api-key-id">Api Key Id</label>
        <div class="input-group mb-1">
          <input
            formControlName="apiKeyId"
            class="form-control"
            id="api-key-id"
            type="text"
          />
        </div>

        <label for="ios-certificate-expiry-date">Data de Expiração do Certificado iOS</label>
        <span>{{iosForm.controls['iosCertificateExpiryDate'].errors | json}}</span>
        <div class="input-group mb-1">
          <input
            formControlName="iosCertificateExpiryDate"
            class="form-control"
            id="ios-certificate-expiry-date"
            type="date"
          />
        </div>

      </div>
      <div class="col-md-4">
        <label for="api-key-issuer-id">Api Key Issuer Id</label>
        <div class="input-group mb-1">
          <input
            formControlName="apiKeyIssuerId"
            class="form-control"
            id="api-key-issuer-id"
            type="text"
          />
        </div>
        <div *ngIf="iosForm.controls['apiKeyIssuerId'].invalid && (iosForm.controls['apiKeyIssuerId'].dirty || iosForm.controls['apiKeyIssuerId'].touched)">
          <small class="text-danger" *ngIf="iosForm.controls['apiKeyIssuerId'].hasError('invalidGuid')">Invalid GUID format.</small>
        </div>

        <label for="api-token-base64">Api Token Base64</label>
        <div class="input-group mb-1">
          <input
            formControlName="apiTokenBase64"
            class="form-control"
            id="api-token-base64"
            type="text"
          />
        </div>

        <label for="one-signal-bundle-id">One Signal Bundle Id</label>
        <div class="input-group mb-1">
          <input
            formControlName="oneSignalBundleId"
            class="form-control"
            id="one-signal-bundle-id"
            type="text"
          />
        </div>

        <label for="app-provision-profile-specifier"
          >App Provision Profile Identifier</label
        >
        <div class="input-group mb-1">
          <input
            formControlName="appProvisionProfileSpecifier"
            class="form-control"
            id="app-provision-profile-specifier"
            type="text"
          />
        </div>

        <label for="onesignal-provision-profile-specifier"
          >One Signal Provision Profile Identifier</label
        >
        <div class="input-group mb-1">
          <input
            formControlName="onesignalProvisionProfileSpecifier"
            class="form-control"
            id="onesignal-provision-profile-specifier"
            type="text"
          />
        </div>
      </div>
    </div>

    <div [class.d-none]="tabs !== 1" class="row">
      <div class="col-md-4">
        <label for="app-provision-profile-link">App Provision Profile</label>
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="app-provision-profile-link"
            formControlName="appProvisionProfileLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-provisioning-profiles-upload
            [type]="'appProvisionProfile'"
            (successEvent$)="onAppProvisionProfileUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-provisioning-profiles-upload>
        </div>

        <label for="onesignal-provision-profile-link"
          >OneSignal Provision Profile</label
        >
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="onesignal-provision-profile-link"
            formControlName="oneSignalProvisionProfileLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-provisioning-profiles-upload
            [type]="'oneSignalProvisionProfile'"
            (successEvent$)="onOneSignalProvisionProfileUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-provisioning-profiles-upload>
        </div>

        <label for="p12-certificate-link">Certificate</label>
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="p12-certificate-link"
            formControlName="p12CertificateLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-certificate-upload
            (successEvent$)="onCertificateUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-certificate-upload>
        </div>
      </div>
      <div class="col-md-4">
        <label for="icons-link">Icons</label>
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="icons-link"
            formControlName="iconsLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-icons-upload
            [type]="'icons'"
            (successEvent$)="onIconsUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-icons-upload>
        </div>

        <label for="app-icon-link">App Icon</label>
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="app-icon-link"
            formControlName="appIconLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-icons-upload
            [type]="'appIcon'"
            (successEvent$)="onIconsUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-icons-upload>
        </div>

        <label for="google-service-plist-link">Google Service Plist</label>
        <div class="align-items-center gap-2 input-group mb-1">
          <input
            readonly
            id="google-service-plist-link"
            formControlName="googleServicePlistLink"
            type="text"
            class="form-control"
          />
          <app-whitelabel-ios-plist-upload
            (successEvent$)="onPlistUploadSuccess($event)"
            (errorEvent$)="onFileUploadError()"
          ></app-whitelabel-ios-plist-upload>
        </div>
      </div>
    </div>
  </div>
</form>
